<template>
  <svg viewBox="0 0 22 23" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 15a1 1 0 0 1 .993.883L22 16v6a1 1 0 0 1-.883.993L21 23H1a1 1 0 0 1-.993-.883L0 22v-6a1 1 0 0 1 1.993-.117L2 16v5h18v-5a1 1 0 0 1 1-1zM11 0a1 1 0 0 1 .993.883L12 1v12.585l4.293-4.292a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 0 1.414l-6 6A1.006 1.006 0 0 1 11 17h-.032l-.054-.004L11 17a1.008 1.008 0 0 1-.595-.196.999.999 0 0 1-.112-.097l.09.08a1.006 1.006 0 0 1-.09-.08l-6-6a1 1 0 0 1 1.414-1.414L10 13.585V1a1 1 0 0 1 1-1z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
